import React from 'react';
import { Section } from './ui/Section';
import { Container } from './ui/Container';
import { BookOpenIcon, ClipboardListIcon, GraduationCapIcon, PenToolIcon, FileTextIcon, LayersIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductFeatures() {
  const features = [{
    icon: CalendarIcon,
    title: 'Planificaciones Completas',
    description: 'Estructuras anuales y mensuales listas para adaptar a tu contexto escolar.'
  }, {
    icon: ClipboardListIcon,
    title: 'Actividades Prácticas',
    description: 'Ejercicios diseñados para captar la atención y reforzar el aprendizaje.'
  }, {
    icon: FileTextIcon,
    title: 'Evaluaciones y Rúbricas',
    description: 'Herramientas claras para medir el progreso de tus estudiantes objetivamente.'
  }, {
    icon: GraduationCapIcon,
    title: 'Guías Docentes',
    description: 'Orientaciones pedagógicas para sacar el máximo provecho a cada recurso.'
  }, {
    icon: PenToolIcon,
    title: 'Formatos Editables',
    description: 'Archivos Word y PowerPoint para que modifiques lo que necesites.'
  }, {
    icon: LayersIcon,
    title: 'Recursos Complementarios',
    description: 'Material extra para enriquecer tus clases y profundizar contenidos.'
  }];
  return <Section background="navy" id="beneficios" data-id="element-133">
      <Container data-id="element-134">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-135">
          <div data-id="element-136">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-137">
              Lo que ofrecemos en nuestros{' '}
              <span className="text-brand-amber-500" data-id="element-138">MegaPacks</span>
            </h2>
            <p className="text-brand-cream-100 text-lg mb-8 leading-relaxed" data-id="element-139">
              Nuestros materiales están desarrollados por expertos en educación
              para cubrir todas las necesidades del aula moderna. Cada MegaPack
              incluye recursos completos y estructurados.
            </p>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-140">
              {features.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-4" data-id="element-141">
                  <div className="flex-shrink-0 mt-1" data-id="element-142">
                    <feature.icon className="w-6 h-6 text-brand-amber-500" data-id="element-143" />
                  </div>
                  <div data-id="element-144">
                    <h4 className="text-white font-semibold mb-1" data-id="element-145">
                      {feature.title}
                    </h4>
                    <p className="text-brand-cream-100/70 text-sm" data-id="element-146">
                      {feature.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          <div className="relative" data-id="element-147">
            <div className="absolute inset-0 bg-brand-amber-500 blur-[100px] opacity-20 rounded-full" data-id="element-148"></div>
            <motion.div initial={{
            scale: 0.9,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 shadow-2xl" data-id="element-149">
              <div className="space-y-4" data-id="element-150">
                {/* Mockup of file list */}
                {[1, 2, 3, 4].map(i => <div key={i} className="flex items-center gap-4 p-4 bg-white/5 rounded-lg border border-white/5 hover:bg-white/10 transition-colors" data-id="element-151">
                    <div className="h-10 w-10 bg-brand-amber-500/20 rounded flex items-center justify-center text-brand-amber-500" data-id="element-152">
                      <FileTextIcon size={20} data-id="element-153" />
                    </div>
                    <div className="flex-1" data-id="element-154">
                      <div className="h-2 w-3/4 bg-white/20 rounded mb-2" data-id="element-155"></div>
                      <div className="h-2 w-1/2 bg-white/10 rounded" data-id="element-156"></div>
                    </div>
                    <div className="text-brand-amber-500 font-mono text-xs" data-id="element-157">
                      DOCX
                    </div>
                  </div>)}
              </div>
              <div className="mt-8 text-center" data-id="element-158">
                <p className="text-white font-medium" data-id="element-159">
                  Más de 100+ archivos listos para usar
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </Container>
    </Section>;
}
function CalendarIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-160">
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" data-id="element-161" />
      <line x1="16" x2="16" y1="2" y2="6" data-id="element-162" />
      <line x1="8" x2="8" y1="2" y2="6" data-id="element-163" />
      <line x1="3" x2="21" y1="10" y2="10" data-id="element-164" />
    </svg>;
}